import React from 'react';
import styles from './onboarding.module.css';
import buttonStyles from './discover-button.module.css';
import WeekAnimation from '../WeekAnimation';
import HandDrawnArrows from './HandDrawnArrows';
import '../css/bigpicturebutton.css'

export default function Outcome() {
    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '1.5rem' }}>
                <h1 className={styles.onboardingGreeting}>
                    Zoom out Fridays!
                </h1>
                <div className={styles.flexDiv} style={{ position: 'relative' }}>
                    <p className={styles.para} style={{ margin: "0 1rem" }}>
                        As your week fills in Normili pulls the patterns together.
                    </p>
                    <WeekAnimation animate={false} />
                    <HandDrawnArrows />
                    <div className={buttonStyles.discoverFauxBtn}>
                        Reflect & Discover ✨
                    </div>
                </div>
                <div style={{ textAlign: "center" }}>
                    <p className={styles.para} style={{ margin: "0.5rem 0.3rem" }}>
                        At the close, you gain a <b>bird's eye view</b> of what uplifted and depleted you.
                    </p>
                </div>
            </div>
        </>
    );
}
